export const getWithResultContainerStyles = () =>
  ({
    withResultContainer: {
      border: 'solid 1px #ccc',
    },

    withResultContent: {
      display: 'flex',

      '& .ba-cascader-selector': {
        border: 0,
      },
    },

    multiSelectorResultContainer: {
      minWidth: 300,
      marginTop: 45,
      marginRight: 15,
    },

    saveBar: {
      padding: '10px 15px',
    },
  });
